// ponytail: il sito e' in anteprima; al go-live diventa https://praticheenergia.com
// (vedi .work/active-task.md).
export const URL_SITO = 'https://anteprima.praticheenergia.com'
export const EMAIL_ASSISTENZA = 'info@praticheenergia.com'
